import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

@Component({
  selector: 'z-hint',
  templateUrl: './hint.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HintComponent {
  /**
   * Text used for this hint. This value should come pre-translated.
   */
  @Input() text: string;

  /**
   * When true the hint will be shown with an invalid state class applied
   */
  @Input() invalid: boolean = false;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  update() {
    this.changeDetectorRef.detectChanges();
  }
}
